// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BudgetFieldsController from "./budget_fields_controller"
application.register("budget-fields", BudgetFieldsController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ClientProjectFilterController from "./client_project_filter_controller"
application.register("client-project-filter", ClientProjectFilterController)

import FinancialsChartController from "./financials_chart_controller"
application.register("financials-chart", FinancialsChartController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InvoiceMonthPickerController from "./invoice_month_picker_controller"
application.register("invoice-month-picker", InvoiceMonthPickerController)

import LedgerController from "./ledger_controller"
application.register("ledger", LedgerController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import NewProjectModalController from "./new_project_modal_controller"
application.register("new-project-modal", NewProjectModalController)

import ReportFilterController from "./report_filter_controller"
application.register("report-filter", ReportFilterController)

import ReportRowController from "./report_row_controller"
application.register("report-row", ReportRowController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import TimeEntryFormController from "./time_entry_form_controller"
application.register("time-entry-form", TimeEntryFormController)
